import { Fish, Phone, ShoppingBag, Wrench } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Section, SectionHeading, InfoCard } from "../components/Section";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

export default function Supplies() {
  return (
    <>
      <Seo
        title="Marina Store & Lake Supplies | West Branch Marina"
        description="Our marina store carries boating equipment, fishing bait and maintenance supplies. Call (330) 296-9209 to check stock before you drive out."
        path="/supplies"
        image="/images/marina_store_supplies.jpeg"
      />

      <PageHero
        image="/images/marina_store_supplies.jpeg"
        alt="Shelves of boating and fishing supplies inside the marina store"
        eyebrow="Supplies"
        title="The store at the dock"
        subtitle="The things you only remember once you're already at the water."
      />

      <Section tone="white">
        <SectionHeading
          eyebrow="What we carry"
          title="Boating, fishing and maintenance"
          intro="Stock varies through the season. If you need something specific, call ahead and we'll check for you."
        />
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          <InfoCard icon={ShoppingBag} title="Boating equipment" testId="supplies-card-boating">
            Gear and accessories for a day on the lake.
          </InfoCard>
          <InfoCard icon={Fish} title="Fishing bait" testId="supplies-card-bait">
            Bait for a morning on the water.
          </InfoCard>
          <InfoCard icon={Wrench} title="Maintenance supplies" testId="supplies-card-maintenance">
            Supplies for keeping your own boat running right.
          </InfoCard>
        </div>

        <div className="mt-12 flex flex-col items-start gap-4 rounded-2xl border border-sand-border bg-sand p-7 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="font-display text-xl font-semibold text-navy">Looking for something in particular?</h2>
            <p className="mt-2 text-sm text-slate-600">Give the marina a call and we'll tell you what's on the shelf.</p>
          </div>
          <a
            href={WB.phoneHref}
            data-testid="supplies-call-link"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-ember px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-ember-hover"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            Call {WB.phone}
          </a>
        </div>
      </Section>
    </>
  );
}
